import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ProductsService } from 'src/app/shared/services/products/products.service';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CheckboxModel } from 'src/app/shared/models/common.model';

@Component({
  selector: 'app-credit-selection',
  templateUrl: './credit-selection.component.html',
  styleUrls: ['./credit-selection.component.scss'],
})
export class CreditSelectionComponent implements OnInit {

  formGroup: FormGroup;
  i: any = 0;
  flag = false;
  credit = 'AAAAAAAAA';
  showOptions: boolean;
  checkboxList: any;
  checkboxTerms: any;
  cuenta = '12347516';
  creditsList: any[];
  array: string[];
  checkboxListPrivate: any;
  value: any[];
  newcheckboxList: Array<{ id: string; label: string; value: string; }>;
  constructor(
    public copyService: CopyService,
    private navigationService: NavigationService,
    private bitacora: BitacoraService,
    private headerService: HeaderService,
    private formBuilder: FormBuilder,
    private abreCuentasService: AbreCuentasService,
    private productService: ProductsService,
    private parameterService: ParametersService,
  ) {
    this.headerService.show(true, false, true);
    this.formGroup = this.formBuilder.group({});
    this.showOptions = false;
    this.checkboxList = [
      {
        id: 'option1',
        label: 'Libranza',
        value: '12347516',
        monto: '$7.581.001',
        checked: false,
      },
      {
        id: 'option2',
        label: 'Libranza',
        value: '12345432',
        monto: '$30.090.000',
        checked: false,
      },
      {
        id: 'option3',
        label: 'Crédito de Libre destino',
        value: '12341234',
        monto: '$10.590.000',
        checked: false,
      },
      {
        id: 'option4',
        label: 'Crédito de Libre destino',
        value: '12345678',
        monto: '$15.120.00',
        checked: false,
      },
    ];
  }

  ngOnInit() {
    console.log('Credit selection screnn');
    this.formGroup = new FormGroup({
      check: new FormControl('', [Validators.required]),
    });
    this.newcheckboxList = this.checkboxList;
    this.censura();
  }

  censura() {
    this.checkboxListPrivate = this.checkboxList;
    for (let j = 0; j < 4; j++) {
      this.array = this.checkboxListPrivate[j].value.split('');
      for (let i = 0; i < 4; i++) {
        this.array[i] = '*';
      }
      this.checkboxListPrivate[j].value = this.array.join('');
    }
  }

  checkboxChange(): void {
    if (this.flag == false) {
      this.flag = true;
    } else {
      /* istanbul ignore next */
      if (this.flag == true) {
        this.flag = false;
      }
    }

  }

  next() {
    this.abreCuentasService.setCreditSelection(this.newcheckboxList);
    this.navigationService.nextStep('200');
  }
}
